import { useState } from "react";
import { Cookie } from "lucide-react";
import "./azhome.css";

const KEY = "imperio_cookie_consent";

export const cookieChoice = () => localStorage.getItem(KEY);

const applyChoice = (v) => {
  // Reject keeps only essential cookies (login session); analytics stops capturing.
  try { if (v === "essential") window.posthog?.opt_out_capturing?.(); else window.posthog?.opt_in_capturing?.(); } catch { /* analytics not loaded */ }
};
if (cookieChoice() === "essential") setTimeout(() => applyChoice("essential"), 0);

export const CookieBar = () => {
  const [open, setOpen] = useState(() => !cookieChoice());
  if (!open) return null;
  const choose = (v) => { localStorage.setItem(KEY, v); applyChoice(v); setOpen(false); };
  return (
    <div className="az-cookie" role="dialog" aria-label="Cookie notice" data-testid="cookie-bar">
      <Cookie size={22} className="az-cookie-ic" />
      <p>We use cookies to improve your experience on our website. By continuing to browse you agree to our use of cookies. You can reject non-essential cookies — your login will keep working.</p>
      <div className="az-cookie-btns">
        <button className="az-hbtn az-hbtn-primary" onClick={() => choose("all")} data-testid="cookie-accept">Got it</button>
        <button className="az-hbtn az-cookie-reject" onClick={() => choose("essential")} data-testid="cookie-reject">Reject</button>
      </div>
    </div>
  );
};
